import { Option } from '../../interfaces/ProyectosDTOS/Option'

export interface Mencion {
    iId: number;
    iIdUnidad: number;
    iIdCampo: number;
    strTipoNivelFormacion: string;
    strNombrePrograma: string;
    strURLImagen: string | null;
    strModalidad: string;
    strCodigoModalidad: string;
    strInformacionModalidad: string | null;
    iMesesDuracion: number;
    dMatricula: number;
    dArancel: number;
    dCostoPrograma: number;
    strNombreTitulo: string;
    lMenciones: string[];
    strCuenta: string | null;
    strPublica: string;
    isEditable: boolean | null;
  }
  
  export interface Programa {
    iId: number;
    iIdUnidad: number;
    iIdCampo: number;
    strTipoNivelFormacion: string;
    strNombrePrograma: string;
    strURLImagen: string | null;
    strModalidad: string;
    strCodigoModalidad: string;
    strInformacionModalidad: string | null;
    iMesesDuracion: number;
    dMatricula: number;
    dArancel: number;
    dCostoPrograma: number;
    strNombreTitulo: string;
    lMenciones: string[];
    strCuenta: string | null;
    strPublica: string;
    isEditable: boolean | null;
  }

export function CastProgramaPostGradotoOption(docto: Programa): Option{
    return{
        value: docto.iId,
        label: docto.strNombrePrograma
    }    
}

export function CastListProgramaPostGradotoListOption(doctos: Array<Programa>): Array<Option>{
    let resp: Array<Option> = []
    doctos.forEach(element => {
     let d = CastProgramaPostGradotoOption(element);
     resp.push(d);   
    });
    return resp
}
  
  export interface RespuestaPostGrado<T> {
    mensaje: string;
    estado: number;
    item: T[];
    estadoTextual: string;
    stacktrace: string;
  }

  export interface RespuestaPostGradoSimple<T> {
    mensaje: string;
    estado: number;
    item: T;
    estadoTextual: string;
    stacktrace: string;
  }